import React from 'react';
import { HashLink } from 'react-router-hash-link';
// model
import Data from '../../model/Data';
import AreaInterface from '../../model/Area';
import CityInterface from '../../model/City';
// common components
import Select from '../../common/components/Select/Select';
// local components
import Header from './components/Header/Header';
import HrMission from './components/HrMission/HrMission';
import ReferalLink from './components/ReferalLink/ReferalLink';
import AboutLink from './components/AboutLink/AboutLink';
import AsideRunner from './components/AsideRunner/AsideRunner';
// styles
import './FirstPage.css';
import './FirstPage320.css';
import './FirstPage768.css';
import './FirstPage1024.css';
import './FirstPage1280.css';
import './FirstPage1376.css';
import './FirstPage1920.css';
import useYandexRotor from "../../common/helpers/useYandexRotor";

interface Props {
  className?: string
}

class FirstPage extends React.Component<Props, {selectedCity: CityInterface}> {

  constructor(props: Props) {
    super(props);
    this.state = {
      selectedCity: Data.Instance.citiesWithVacancies[0],
    };
    this.onCityChange = this.onCityChange.bind(this);
  }

  onCityChange(cityId: string): void {
    const city = Data.Instance.cityById(cityId);
    this.setState((prevState) => ({ ...prevState, selectedCity: city }));
  }

  private areaView(city: CityInterface, area: AreaInterface): JSX.Element {
    return (
      <HashLink
        className="activity"
        key={`${city.id}/${area.id}`}
        to={`${city.uri_alias}#${area.uri_alias}`}>
          {area.name}
      </HashLink>
    );
  }

  private areasView(city: CityInterface): JSX.Element {
    const areas = Data.Instance.areasByCity(city.id);
    let content;

    if (areas.length > 0) {
      content = areas.map((a) => this.areaView(city, a))
    } else {
      content = (
        <div key='no-area-block' className="alert alert-info">
          Не найдены вакансии в выбранном городе
      </div>);
    }

    return (
      <div className="select-activity">
        { content }
      </div>
    );
  }

  render(): JSX.Element {
    const cities = Data.Instance.citiesWithVacancies;
    const { selectedCity } = this.state;
    const vacanciesReferal = Data.Instance.vacanciesReferal();

    useYandexRotor(Data.Instance.isDataLoaded);

    return (
      <div className="first-page">
        <div className="container">
          <Header brand={Data.Instance.company} withMission={true} />
          <main className="main">
            {
              selectedCity && this.areasView(selectedCity)
                ?
                  <>
                    <div className="select-city">
                      <span>Вакансии</span>
                      <Select
                          className="city-select"
                          selected={selectedCity.id}
                          options={Data.Instance.citiesAsOptions(cities)}
                          onChange={this.onCityChange}
                      />
                    </div>
                    { this.areasView(selectedCity) }
                  </>
                : <div className="select-city">
                    <span>Вакансий нет :)</span>
                  </div>
            }
          </main>
          <div className="bottom-block">
            <div className="links-block">
              {vacanciesReferal.length > 0 && <ReferalLink />}
              <AboutLink />
            </div>
            <HrMission />
          </div>
        </div>
        <AsideRunner cities={cities.map((c) => c.name)} />
      </div>
    );
  }
}

export default FirstPage;
